// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'scale-up';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1 6.333V2.067A1.067 1.067 0 0 1 2.067 1h4.266m10.666 5.333V2.067A1.067 1.067 0 0 0 15.932 1h-4.266M1 11.666v4.267A1.067 1.067 0 0 0 2.067 17h4.266m10.666-5.334v4.267A1.067 1.067 0 0 1 15.932 17h-4.266M4.2 4.2h9.6v9.6H4.2z'
  />
);

export const viewBox = '0 0 18 18';
